module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "textSection"
  }, [_c('h1', [_vm._v("Présentation de la formation Savoir Être Aidant")]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Savoir Être Aidant")]), _vm._v(" est une formation gratuite et ouverte à tous dont l’objectif est de permettre une meilleure compréhension des enjeux du vieillissement et du rôle des aidants. ")]), _vm._v(" "), _c('p', [_vm._v("Aujourd’hui en France, on dénombre plus de 11 millions d’aidants non-professionnels et ce nombre est en constante croissance dû au vieillissement de la population française. Comme vous le savez ou allez le découvrir au travers la formation "), _c('em', [_vm._v("Savoir Être Aidant")]), _vm._v(" , ces derniers jouent un rôle essentiel dans le maintien à domicile de leurs proches.  Volontaires, patients, humains et dédies, les aidants sont souvent la clé de voûte permettant à leurs proches de poursuivre une vie normale malgré leur perte d’autonomie. Pourtant, aucune formation ne leur est destinée. ")]), _vm._v(" "), _c('p', [_vm._v("C’est au regard de ces enjeux touchant les aidants que les associations Campus Urbain et FuturÂge, avec le soutien financier du Fonds Européen de Développement Régional et du Territoire Grand-Orly Seine Bièvre, ont décidé de construire une formation qui leur est dédiée. Menée en partenariat avec les équipes gériatriques de l’Hôpital Charles Foix et les acteurs franciliens du vieillissement, "), _c('em', [_vm._v("Savoir Être Aidant")]), _vm._v("  vous offrira la possibilité d’appréhender avec plus de sérénité votre rôle d’aidant tout en identifiant les dispositifs et les structures sur lesquels vous pourrez vous appuyer. ")]), _vm._v(" "), _c('h2', [_c('em', [_vm._v("Savoir Être Aidant")]), _vm._v(" , une formation construite avec les partenaires clés sur le vieillissement en Île-de-France")]), _vm._v(" "), _c('p', [_vm._v("Pour mener à bien ce projet, Campus Urbain et FuturÂge ont collaboré avec leurs partenaires du vieillissement. La diversité des structures et leur rôle ont permis à la formation "), _c('em', [_vm._v("Savoir Être Aidant")]), _vm._v("  d’aborder sous de nombreux angles les enjeux du vieillissement. ")]), _vm._v(" "), _c('p', [_vm._v("Un grand merci à :")]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("Sylvie Pariel")]), _vm._v(", gériatre et "), _c('strong', [_vm._v("Joël Belmin")]), _vm._v(", professeur en gériatrie à "), _c('a', {
    attrs: {
      "href": "http://charlesfoix.aphp.fr/",
      "target": "_blank"
    }
  }, [_vm._v("l’hôpital Charles Foix - Assistance Publique – Hôpitaux de Paris, Groupe Pitié Salpêtrière.")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Claudie Kulak")]), _vm._v(", fondatrice de "), _c('a', {
    attrs: {
      "href": "https://www.lacompagniedesaidants.com",
      "target": "_blank"
    }
  }, [_vm._v("La Compagnie des Aidants.")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Camille Mairesse")]), _vm._v(", Responsable du pilotage et du développement du "), _c('a', {
    attrs: {
      "href": "http://www.prif.fr/",
      "target": "_blank"
    }
  }, [_vm._v("PRIF – Prévention Retraite en Ile-de-France.")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Hervé Robert")]), _vm._v(", Directeur de "), _c('a', {
    attrs: {
      "href": "http://agesetvie.fr/",
      "target": "_blank"
    }
  }, [_vm._v("l’Association Âges et Vie.")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Bastien Zemb et Adrien Euphrasie")]), _vm._v(", ergothérapeutes et co-fondateurs de "), _c('a', {
    attrs: {
      "href": "http://www.bel-avie.com/",
      "target": "_blank"
    }
  }, [_vm._v("Bel'Avie.")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Agnès Michon")]), _vm._v(", Neurologue à "), _c('a', {
    attrs: {
      "href": "http://icm-institute.org/fr/",
      "target": "_blank"
    }
  }, [_vm._v("l’Institut du Cerveau et de la Moelle Épinière de l’Assistance Publique – Hôpitaux de Paris, Pitié Salpêtrière.")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Jean-Marie Billard-Madrières")]), _vm._v(", fondateur "), _c('a', {
    attrs: {
      "href": "http://www.lapins-bleus.com/",
      "target": "_blank"
    }
  }, [_vm._v("des Lapins Bleus")]), _vm._v(". ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Christophe Ambroise")]), _vm._v(", chargé de mission Mobilité au "), _c('a', {
    attrs: {
      "href": "http://autonomie.valdemarne.fr/?q=node/22",
      "target": "_blank"
    }
  }, [_vm._v("Conseil départemental du Val-de-Marne.")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Benjamin Zimmer")]), _vm._v(", Directeur du "), _c('a', {
    attrs: {
      "href": "http://www.silvervalley.fr",
      "target": "_blank"
    }
  }, [_vm._v("Silver Valley.")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Catherine Ollivet")]), _vm._v(", Présidente de "), _c('a', {
    attrs: {
      "href": "http://www.francealzheimer.org/",
      "target": "_blank"
    }
  }, [_vm._v("France Alzheimer Seine Saint-Denis.")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Christophe Bouché")]), _vm._v(", psychiatre à l’"), _c('a', {
    attrs: {
      "href": "http://charlesfoix.aphp.fr/",
      "target": "_blank"
    }
  }, [_vm._v("hôpital Charles Foix - Assistance Publique – Hôpitaux de Paris, Groupe Pitié Salpêtrière.")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "info-mobile"
    }
  }, [_c('h2', [_c('em', [_vm._v("Savoir Être Aidant")]), _vm._v(" est aussi disponible sur mobile !")]), _vm._v(" "), _c('p', [_vm._v("Une application mobile est disponible sur iOS et Android")]), _vm._v(" "), _c('p', [_vm._v("iOS : "), _c('a', {
    attrs: {
      "href": "https://apps.apple.com/fr/app/savoir-%C3%AAtre-aidant/id1617996054",
      "target": "_blank"
    }
  }, [_vm._v("télécharger-là ici")]), _vm._v("! ")]), _vm._v(" "), _c('p', [_vm._v("Android : "), _c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.campusurbain.savoiretreaidant",
      "target": "_blank"
    }
  }, [_vm._v("télécharger-là ici")]), _vm._v(" !")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b9d4565"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 441
// module chunks = 1